import { Space } from 'antd';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import LayoutInner from '../../../../layouts/main/components/layout-inner/layout-inner';
import PageTitle from '../../../../shared/components/page-title/page-title';
import AuthGuard from '../../../auth/components/auth-guard/auth-guard';
import { UserPermissionType } from '../../../user/models/user-permission-type';
import ScanRequestsGraph from '../../components/scan-requests-graph/scan-requests-graph';
import SignRequestsGraph from '../../components/sign-requests-graph/sign-requests-graph';
import styles from './dashboard.module.css';
import SignedDocumentsByUser from '../../components/signed-documents-by-user/signed-documents-by-user';
import SignedDocumentsByTemplate from '../../components/signed-documents-by-template/signed-documents-by-template';

const Dashboard = (): JSX.Element => {
  const { t } = useTranslation('common');

  return (
    <AuthGuard permission={UserPermissionType.ViewDashboard}>
      <Helmet>
        <title>{t('menu.dashboard')}</title>
      </Helmet>
      <LayoutInner>
        <PageTitle>{t('menu.dashboard')}</PageTitle>
        <Space className={styles.container} direction="vertical">
          <SignRequestsGraph />
          <SignedDocumentsByTemplate />
          <SignedDocumentsByUser />
          <ScanRequestsGraph />
        </Space>
      </LayoutInner>
    </AuthGuard>
  );
};

export default Dashboard;
